// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.criteria.RentalManagerUserPropertyCriteriaWebApiHandler

import type { QueryOptions, UseMutationOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useMutation, useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerUserPropertyCriteriaWebApiHandler_get,
  RentalManagerUserPropertyCriteriaWebApiHandler_get_Path,
  RentalManagerUserPropertyCriteriaWebApiHandler_set,
} from '@zg-rentals/ts-rental-manager-api-client';

import type {
  ListingAlias,
  UserPropertyCriteriaGetResponseWebDto,
  UserPropertyCriteriaSetRequestWebDto,
} from '@zg-rentals/ts-rental-manager-api-client';

interface GetParams {
  listingAlias: ListingAlias;
}
interface SetParams {
  listingAlias: ListingAlias;
}

export type RentalManagerUserPropertyCriteriaWebApiHandler_get_Options = UseQueryOptions<
  UserPropertyCriteriaGetResponseWebDto,
  unknown,
  UserPropertyCriteriaGetResponseWebDto,
  readonly [string, GetParams]
>;

const RentalManagerUserPropertyCriteriaWebApiHandler_get_GetKey = (getParams: GetParams) =>
  [RentalManagerUserPropertyCriteriaWebApiHandler_get_Path, getParams] as const;

export const RentalManagerUserPropertyCriteriaWebApiHandler_get_queryOptions = (
  getParams: GetParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserPropertyCriteriaWebApiHandler_get_GetKey(getParams),
    queryFn: () => RentalManagerUserPropertyCriteriaWebApiHandler_get(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get criteria for a listing
 */
export const useRentalManagerUserPropertyCriteriaWebApiHandler_get = (
  getParams: GetParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerUserPropertyCriteriaWebApiHandler_get_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerUserPropertyCriteriaWebApiHandler_get_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerUserPropertyCriteriaWebApiHandler_get.getKey =
  RentalManagerUserPropertyCriteriaWebApiHandler_get_GetKey;

export interface RentalManagerUserPropertyCriteriaWebApiHandler_set_Args {
  getParams: SetParams;
  postData: Array<UserPropertyCriteriaSetRequestWebDto>;
}

export type RentalManagerUserPropertyCriteriaWebApiHandler_set_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyCriteriaWebApiHandler_set_Args
>;

/**
 * Set criteria for a listing
 */
export const useRentalManagerUserPropertyCriteriaWebApiHandler_set = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyCriteriaWebApiHandler_set_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyCriteriaWebApiHandler_set_Args) =>
      RentalManagerUserPropertyCriteriaWebApiHandler_set(args.getParams, args.postData, httpClient),
  });
};
